import { hot } from 'react-hot-loader/root';
import React, { FunctionComponent } from 'react';
import useWidgetContext from '../react/useWidgetContext';
import CommonEvents from '../../../../common/constants/events';
import ThemeProvider from './providers/ThemeProvider';
import AltSpcWidgetRouter from './AltSpcWidgetRouter';
import ParallelContextualizedInitializer from './ParallelContextualizedInitializer';
import PlatformConfigProvider from './providers/PlatformConfigProvider';
import PlatformJsonnetConfigProvider from './providers/PlatformJsonnetConfigProvider';
import MinimalLoader from '../components/presentation/MinimalLoader';
import { ApolloProvider } from '@apollo/client';
import useApolloClient from '../hooks/useApolloClient';
import GqlTranslationsProvider from './providers/GqlTranslationProvider';
import { BrowserRouter } from 'react-router-dom';
import httpClient from '../api/httpClient';
import useNewJsonnetApi from '../../../../common/utilities/useNewJsonnetApi';

const AltSpcWidget: FunctionComponent = () => {
  const { client } = useApolloClient();
  const { configuration, eventContainer } = useWidgetContext();
  httpClient.configure(configuration?.cookieDomain || '', configuration?.dimensions);
  eventContainer.emit(CommonEvents.INITIALIZED);
  const useNewApi = useNewJsonnetApi(configuration.dimensions);

  return (
    <ApolloProvider client={client}>
      <ParallelContextualizedInitializer
        initializers={[
          ThemeProvider,
          useNewApi ? PlatformJsonnetConfigProvider : PlatformConfigProvider,
          GqlTranslationsProvider,
        ]}
        loader={<MinimalLoader />}
      >
        <BrowserRouter basename={configuration.basePath}>
          <AltSpcWidgetRouter />
        </BrowserRouter>
      </ParallelContextualizedInitializer>
    </ApolloProvider>
  );
};

export default hot(AltSpcWidget);
